import { jsx, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import { EGDSCarouselItem } from '../carousel-item/index.esm.js';
const EGDSCarouselItemList = props => {
  const {
    children,
    l10n,
    size,
    currentIndex,
    itemCount,
    ...itemProps
  } = props;
  const {
    itemsVisible
  } = itemProps;
  const newChildren = React.Children.toArray(children);
  const getCarouselItems = () => {
    const items = newChildren;
    const currentItemsVisible = itemsVisible[size];
    // Determines the grouping to apply aria-hidden to.
    const startOfCurrentGroup = currentIndex;
    const startOfNextGroup = currentIndex + currentItemsVisible;
    const elements = React.Children.map(items, (elm, i) => {
      const ariaHidden = i < startOfCurrentGroup || i >= startOfNextGroup;
      const ariaLabel = l10n?.formatText('carousel.indexAndTotal', i + 1, itemCount);
      return jsx(EGDSCarouselItem, {
        itemIndex: i,
        ariaHidden: ariaHidden,
        ariaLabel: ariaLabel,
        ...itemProps,
        children: elm
      }, i);
    });
    return elements;
  };
  return jsx(Fragment, {
    children: getCarouselItems()
  });
};
EGDSCarouselItemList.displayName = 'EGDSCarouselItemList';
export { EGDSCarouselItemList };